import React, { Component } from 'react'
import './components.css'

export default class TutorialCard extends Component {
    render() {
        return (
            <div className="card-container">
                <div className="card-title">{this.props.title}</div>
                <div className="card-content">
                    {this.props.content}
                </div>
            </div>
        )
    }
}
